/* eslint-disable react/prop-types */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useState } from "react";
import { Eye } from "lucide-react";
import { InfoDialog } from "@/components/dialog/info-dialog";
import { formatCurrency } from "@/lib/utils";
import { Tab } from "@material-tailwind/react";

export function TakeAwayItemTable({ data }) {
  const [complementaryDaysDialog, setComplementaryDaysDialog] = useState(false);
  const [selectedComplementaryItem, setSelectedComplementaryItem] =
    useState(null);

  return (
    <div className=" w-full">
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead>Order ID</TableHead>
            <TableHead>Customer Name</TableHead>
            <TableHead>Order Type</TableHead>
            <TableHead>Compensation Type</TableHead>
            <TableHead>Total Value</TableHead>
            <TableHead>Reasons</TableHead>
            <TableHead>Replace Order/ Items</TableHead>
            <TableHead>Code</TableHead>
            <TableHead>Date of Action</TableHead>
            <TableHead>Provided By</TableHead>
            {/* <TableHead>Serve by</TableHead> */}
            {/* <TableHead>Date of Action</TableHead> */}
          <TableHead>Date</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data?.length == 0 && (
            <TableRow>
              <TableCell colSpan="100" className="text-center text-color14">
                No item found
              </TableCell>
            </TableRow>
          )}
          {data?.length > 0 &&
            data?.map((order) => (
              <TableRow key={order?.id || "-"}>
                <TableCell>{order?.id || order?.order_id || "-"}</TableCell>
                <TableCell>{order?.customer_name || "-"}</TableCell>
                <TableCell>{order?.order_type || "-"}</TableCell>
                <TableCell>{order?.compensation_type || "-"}</TableCell>
                <TableCell>£{formatCurrency(order?.price_sum)}</TableCell>
                <TableCell>{order?.reasons || "-"}</TableCell>
                <TableCell>
                  <button
                    onClick={() => {
                      setSelectedComplementaryItem(order);
                      setComplementaryDaysDialog(true);
                    }}
                    className="flex items-center gap-1"
                    >
                    <Eye size={16} />
                    View
                  </button>
                </TableCell>
                <TableCell>{order?.code || "-"}</TableCell>
                <TableCell>{order?.date_of_action || "-"}</TableCell>
                <TableCell>{order?.provide_by}</TableCell>
                <TableCell>{order?.date|| "-"}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <InfoDialog
        isOpen={complementaryDaysDialog}
        onClose={() => {
          setComplementaryDaysDialog(false);
          setSelectedComplementaryItem(null);
        }}
        button={false}
        title="Replaced Order/ Items"
      >
        {selectedComplementaryItem &&
          selectedComplementaryItem?.items &&
          selectedComplementaryItem?.items?.length > 0 && (
            <div className="w-full">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>SL</TableHead>
                    <TableHead>Name</TableHead>
                    <TableHead>Quantity</TableHead>
                    <TableHead className="text-right">Actual Price</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {selectedComplementaryItem?.items?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell className="">{index + 1}</TableCell>
                      <TableCell>
                        <div>
                          {item?.item_name}
                          {item?.variant && (
                            <span className=" text-xs block">
                              ({item?.variant})
                            </span>
                          )}
                        </div>
                      </TableCell>
                      <TableCell className="">x{item?.quantity}</TableCell>
                      <TableCell className="text-right">
                        {formatCurrency(item?.actual_price)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
      </InfoDialog>
    </div>
  );
}
